import type { CJobOffersTranslations } from "./pl";

export const de: CJobOffersTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Angebote entsprechen den gewählten Kriterien.",
  filterCategory: "Alle Kategorien",
  filterProvince: "Alle Woiwodschaften",
  filterCity: "Alle Städte",
  filterSubmit: "Suchen",
  filterReset: "Filter zurücksetzen",
  filterLabelCategory: "Kategorie",
  filterLabelProvince: "Woiwodschaft",
  filterLabelCity: "Stadt",
  referenceNumber: "Referenznummer",
  publicationDate: "Veröffentlichungsdatum",
  tasksHeading: "Sie werden verantwortlich sein für:",
  expectationsHeading: "Wir erwarten von Ihnen:",
  offerHeading: "Wir bieten:",
  applyButton: "Bewerben",
  goToForm: "Zum Formular",
  attachments: "Anhänge",
  download: "Herunterladen",
  readMore: "Mehr lesen ->",
  backToList: "<- Zurück zur Angebotsliste",
  formatDate: (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)}. ${months[month]} ${m[1]}`;
  },
  formatFileSize: (bytes) => {
    if (!bytes || bytes < 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  },
};
